<template>
    <div id="checklist-container">
        <h3>Daily Checklist</h3>
        <ul>
            <li v-for="item in checklist" :class="{'checklist-subheading': item.children && item.children.length > 0, 'checklist-checked': item.checked}" v-on:click="checkChanged(item)">
                <span class="checklist-title">{{ item.title }}</span>
                <div style="width: 20px; margin-right: 30px;"><checkbox v-if="!item.children || item.children.length < 1" v-model="item.checked"></checkbox></div>
                <!--<input v-if="!item.children || item.children.length < 1" type="checkbox" v-model="item.checked" v-on:change="checkChanged(item)" />-->
                <ul v-if="item.children && item.children.length > 0">
                    <li v-for="child in item.children" v-on:click="checkChanged(child)" :class="{'checklist-checked': child.checked}">
                        <span class="checklist-title">{{ child.title }}</span>
                        <!--<input type="checkbox" v-model="child.checked" v-on:change="checkChanged(child)" />-->
                        <div class="checkbox"><checkbox v-model="child.checked"></checkbox></div>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    import Checkbox from "./Checkbox";
    export default {
        name: "CheckList",
        components: {Checkbox},
        computed: {
            checklist () {
                return this.$store.state.challenge.checklist
            }
        },
        methods: {
            checkChanged (item) {
                item.checked = !item.checked
                this.$store.dispatch('challenge/updateChecklistItem', item)
            }
        }
    }
</script>

<style scoped lang="scss">
    #checklist-container {
        background: #FFFFFF;
    }
    h3 {
        font-size: 20px;
        font-family: 'DIN Alternate Bold';
        text-transform: uppercase;
        color: #FFFFFF;
        background: #24ADBB;
        padding: 5px 0 0 !important;
        display: flex;
        justify-content: center;
    }
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
        list-style-type: none;
        width: 100%;
        li {
            color: #BFBFBF;
        }
        span.checklist-title {

            font-family: 'DIN Alternate Bold';
            font-size: 20px;
            padding: 0;
            padding-left: 15px;
            height: 25px;
        }
    }

    li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        cursor: pointer;
        &.checklist-checked {
            color: #000000;
        }
        &.checklist-subheading {
            flex-direction: column;
            align-items: flex-start;
            cursor: auto;
            ul {
                width: 100%;
            }
            li {
                .checkbox {
                    width: 20px; margin-right: 30px;
                }
                span {
                    margin-left: 15px;
                    white-space: nowrap;
                }
            }
            &> .checklist-title {
                color: #24ADBB;
            }

        }
        input {
            justify-self: flex-end;
        }
        li &:nth-child(even) {
            background: rgba(36,173,187, .08);
        }
        .checkbox {
            width: 20px; margin-right: 30px;
        }
    }
</style>
